import React from 'react';
import { useMobile } from '../../../hooks/useMobile';
import { useCompanyContext } from '../../../contexts/Company';
import { useLinesContext } from '../../../contexts/Lines';
import { getLinePageWidth } from '../../../utils';
import Stepper from '../../../components/Onboarding/BuildingBlocks/OnboardingWrapper';
import PageLayout from '../../../components/Onboarding/Line/LineExplained';

const HEADER = 'Here’s some basic information about Lines.';

const SUBTITLE = (
  <span>
    A <b>‘Line’</b> is all the supply chain expenses associated with selling a
    batch of product — from the cost of inventory to the cost of marketing.
    Typically a Line will include some or all of the <b>stages</b> shown below.
  </span>
);

export default function LineExplained() {
  const mobile = useMobile('sm');
  const { business } = useCompanyContext();
  const { products } = useLinesContext();

  return (
    <>
      <Stepper
        hideContent={!(products && business)}
        title={HEADER}
        subtitle={SUBTITLE}
        headerWidth={getLinePageWidth(mobile)}
        contentWidth={getLinePageWidth(mobile)}
      >
        <PageLayout />
      </Stepper>
    </>
  );
}
